export const COMMUNITY_EVENT_ID_PATTERN = /^[a-z0-9-]{1,64}$/
export const COMMUNITY_EVENT_GOAL_ID_PATTERN = /^[a-z0-9-]{1,32}$/
export const COMMUNITY_EVENT_MAX_GOALS = 3
export const COMMUNITY_EVENT_MAX_SOURCES = 10
export const COMMUNITY_EVENT_MAX_INFO_LENGTH = 1000
export const COUNTRY_CODE_PATTERN = /^[A-Z]{2}$/
export const ALL_COUNTRIES = "*"
export const HEX_COLOR_PATTERN = /^#([0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/i

export const COMMUNITY_EVENT_THEMES = ["halloween", "default"]
export const COMMUNITY_EVENT_REWARD_TYPES = ["coins", "raffleTickets"]
export const COMMUNITY_EVENT_NAV_ICONS = ["pumpkin"]
export const COMMUNITY_EVENT_TOPBAR_DECORS = ["spiderWebs"]
export const COMMUNITY_EVENT_AVATAR_MASKS = ["witchHat"]

export const SHELL_COLOR_FIELDS = [
  { name: "accent", label: "Accent" },
  { name: "topbarMainColor", label: "Top bar main" },
  { name: "topbarSecondColor", label: "Top bar second" },
  { name: "sidebarColor", label: "Sidebar" },
] as const

export const UTC_DATE_TIME_FORMAT = "YYYY-MM-DD HH:mm:ss [UTC]"
export const STORED_DATE_FORMAT = "YYYY-MM-DDTHH:mm:ss[Z]"
export const EXPLICIT_ZONE_PATTERN = /(Z|[+-]\d{2}:?\d{2})$/i

export const toOptions = (values: readonly string[]) => values.map(value => ({ value }))
